import React, { useEffect, useRef, useState } from "react";

export default function MultipleSelector({ options, value, onChange }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);
  function toggleValue(optionValue) {
    if (value.includes(optionValue)) {
      onChange(value.filter((v) => v !== optionValue));
    } else {
      onChange([...value, optionValue]);
    }
  }

  useEffect(() => {
    if (!open) return;

    function handlePointerDown(e) {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("pointerdown", handlePointerDown);

    return () => {
      document.removeEventListener("pointerdown", handlePointerDown);
    };
  }, [open]);

  return (
    <div ref={containerRef} className="relative w-full">
      {/* Trigger */}
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className=" flex h-9 w-full items-center justify-between rounded-md border border-input dark:border-[#5a6880] bg-transparent dark:bg-[#1F2937] px-3 py-4 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-ring"
      >
        <div className="flex items-center gap-2 overflow-hidden">
          {value?.length === 0 && (
            <span className="text-muted-foreground">Select options…</span>
          )}

          {value?.slice(0, 3).map((id) => {
            const opt = options.find((o) => o.value === id);
            const isUnpaid = opt?.label?.toLowerCase() === "unpaid leave";

            return (
              <span
                key={id}
                className={`inline-flex items-center rounded-md px-2 py-1 text-xs
        ${isUnpaid ? "bg-yellow-100 text-yellow-900 dark:bg-yellow-900/30 dark:text-yellow-200 border-yellow-400" : "border border-primary"}`}
              >
                {opt?.label ?? id}
              </span>
            );
          })}

          {value?.length > 3 && (
            <span className="text-xs text-muted-foreground">
              +{value.length - 3} more
            </span>
          )}
        </div>
        <span className="opacity-50">▾</span>
      </button>

      {/* Dropdown */}
      {open && (
        <div className=" absolute left-0 top-full z-50 mt-1 w-full min-w-[8rem] rounded-md border border-input dark:border-[#5a6880] bg-popover text-popover-foreground shadow-md">
          <div className=" max-h-[180px] overflow-auto p-1">
            {options.length === 0 && (
              <p className="p-2 text-sm text-muted-foreground">
                No options available
              </p>
            )}
            {options.map((option) => {
              const isUnpaid = option.label?.toLowerCase() === "unpaid leave";

              return (
                <label
                  key={option.value}
                  className={`relative flex w-full items-center gap-2 rounded-sm px-2 py-2 text-sm transition-colors
        ${isUnpaid ? "bg-gray-200 dark:bg-gray-800/10 cursor-not-allowed" : "cursor-pointer hover:bg-primary/20"}`}
                >
                  <input
                    type="checkbox"
                    disabled={isUnpaid}
                    className={`accent-primary ${isUnpaid ? "cursor-not-allowed opacity-60" : "cursor-pointer"}`}
                    checked={value.includes(option.value)}
                    onChange={() => !isUnpaid && toggleValue(option.value)}
                  />

                  <span className={`truncate ${isUnpaid ? "opacity-70" : ""}`}>
                    {option.label}
                  </span>
                </label>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
